module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_MINDMASTER.f2b9dd2f.png";